import { ActiveModel, ActiveField } from '@alt-point/active-models/src'

/**
* Class UpdateCartProduct
*  Данные для изменения продукта (добавление или изменение кол-ва) корзины
*/
export class UpdateCartProduct extends ActiveModel {

  /**
  * productId
  * Идентификатор продукта<br>  */
  @ActiveField(0)
  productId: number = 0


  /**
  * amount
  * Кол-во продукта. <br><br>Если меньше 1, то продукт будет удалён из корзины<br>  */
  @ActiveField(0)
  amount: number = 0


  /**
  * notifyInStock
  * Если true, то уведомить о появлении товара в наличии. <br><br>Игнорируется для анонимных пользователей<br>  */
  @ActiveField()
  notifyInStock?: boolean
}
